import React from "react";
import styled from "styled-components";

const Root = styled.nav`
  align-items: center;
  display: flex;
  height: 6.25rem;
  position: relative;
  width: 100%;

  .cred-Customer2FaStepper-list {
    align-items: inherit;
    display: flex;
    height: 100%;
    justify-content: space-between;
    list-style: none;
    width: calc(100% - var(--theme-spacing-inline-md, 24px));
  }

  .cred-Customer2FaStepper-item {
    align-items: flex-end;
    background: var(--theme-backgroundColor-Steps-bar, #b3b3b3);
    display: flex;
    height: 0.125rem;
    position: relative;
    top: var(--theme-font-size-sm, 1.5rem);
    width: 100%;
  }

  .cred-Customer2FaStepper-item:first-child {
    background: transparent;
    width: 0.5rem;
  }

  .cred-Customer2FaStepper-item:last-child,
  .cred-Customer2FaStepper-item:nth-child(2) {
    width: 135%;
  }

  .cred-Customer2FaStepper-item::before {
    background-color: var(--theme-background-color--default, #fff);
    border: var(--theme-border-width-medium, 2px)
      var(--theme-border-style--default, solid)
      var(--theme-borderColor-Steps, #707070);
    border-radius: 100%;
    content: "";
    height: var(--theme-font-size-sm, 1.5rem);
    left: 100%;
    position: absolute;
    top: -0.75rem;
    width: var(--theme-font-size-sm, 1.5rem);
    z-index: 1;
  }

  .cred-Customer2FaStepper-item--current,
  .cred-Customer2FaStepper-item--done {
    background: var(--theme-backgroundColor-Steps--active, #da291c);
  }

  .cred-Customer2FaStepper-item--current::before {
    background-color: var(--theme-backgroundColor-Steps--doing, #fff);
    box-shadow: inset 0 0 0 0.25rem
      var(--theme-color-brand-primary-medium, #da291c);
  }

  .cred-Customer2FaStepper-item--done::before {
    background-color: var(--theme-backgroundColor-Steps--checked, #da291c);
  }

  .cred-Customer2FaStepper-item--done::after {
    border: var(--theme-border-width-medium, 2px)
      var(--theme-border-style--default, solid)
      var(--theme-color-Steps-icon, #fff);
    border-right-style: none;
    border-top-style: none;
    content: "";
    height: 0.3125rem;
    left: 100%;
    position: absolute;
    top: -0.875rem;
    transform: translate(0.5em, 0.6em) rotate(-45deg);
    width: 0.5625rem;
    z-index: 1;
  }

  .cred-Customer2FaStepper-text {
    bottom: var(--theme-spacing-inset-lg, 32px);
    color: var(--theme-text-color-Label--default, #1f1d1d);
    font-family: var(--theme-font-family--Heading, Roboto, sans-serif);
    font-size: var(--theme-font-size-xs, 1rem);
    font-weight: var(--theme-font-weight--Heading, 700);
    left: calc(100% - 4.16667rem);
    line-height: var(--theme-font-line-height-xs, 1.25rem);
    position: absolute;
    text-align: center;
    width: 10rem;
  }

  .cred-Customer2FaStepper-item:first-child
    .cred-Customer2FaStepper-text {
    left: 0;
    text-align: left;
  }

  .cred-Customer2FaStepper-item:last-child
    .cred-Customer2FaStepper-text {
    left: calc(100% - 8.5rem);
    text-align: right;
  }
`;

export default function Customer2FaStepper({ activeStep }) {
  const steps = ["Verificação", "Conclusão"];

  return (
    <Root aria-label="Progresso da autenticação">
      <ol className="cred-Customer2FaStepper-list">
        {steps.map((title, index) => {
          const state = index < activeStep ? "done" : index === activeStep ? "current" : "inactive";
          const accessibleState = state === "done" ? "Passo concluído" : state === "current" ? "Passo atual" : "Passo a fazer";

          return (
            <li
              key={title}
              className={`cred-Customer2FaStepper-item cred-Customer2FaStepper-item--${state}`}
              aria-current={state === "current" ? "step" : undefined}
              aria-label={`${accessibleState} - Passo ${index + 1} de ${steps.length}`}
            >
              <span className="cred-Customer2FaStepper-text">{title}</span>
            </li>
          );
        })}
      </ol>
    </Root>
  );
}
